module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "copy-right"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/imgs/portal/logo_color.png",
      "alt": "logo"
    }
  }), _vm._v("Copyright © 2013-" + _vm._s(new Date().getFullYear())), _c('span', [_vm._v(" 鼎程（上海）金融信息服务有限公司 ")]), _vm._v("致电：400-622-8098"), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('div', [_c('span', {
    staticClass: "top"
  }, [_vm._v("群星金融")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('about')
      }
    }
  }, [_vm._v("公司介绍")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('news')
      }
    }
  }, [_vm._v("群星资讯")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "top"
  }, [_vm._v("快速入口")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('product')
      }
    }
  }, [_vm._v("平台产品")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('service')
      }
    }
  }, [_vm._v("供应链金融服务")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('download')
      }
    }
  }, [_vm._v("下载方案")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('service')
      }
    }
  }, [_vm._v("下载白皮书")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "top"
  }, [_vm._v("供应链角色")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('core')
      }
    }
  }, [_vm._v("我是上市公司")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('institution')
      }
    }
  }, [_vm._v("我是金融机构")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('chain', 'n1')
      }
    }
  }, [_vm._v("我是供应商")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('chain', '1n')
      }
    }
  }, [_vm._v("我是经销商")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "top"
  }, [_vm._v("其他")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('join')
      }
    }
  }, [_vm._v("加入群星")])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    staticStyle: {
      "color": "#888888"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn"
    }
  }, [_vm._v("沪ICP备14012246号-1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode"
  }, [_vm._v("关注群星金融公众号"), _c('br'), _vm._v("了解一手供应链金融资讯")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3a30e732"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/Footer.vue
// module id = 1294
// module chunks = 26